import { CheckCircle2, X } from 'lucide-react'

export default function Toast({ message, onClose }) {
  if (!message) return null

  return (
    <div className="fixed right-4 top-4 z-[70] w-[calc(100%-2rem)] max-w-[360px] rounded-xl border border-[#D6CDBF] bg-white p-4 text-[#1A1A1A] shadow-[0_18px_45px_rgba(26,26,26,0.14)] sm:right-6 sm:top-6">
      <div className="grid grid-cols-[32px_minmax(0,1fr)_28px] items-start gap-3">
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[#DDF4E7] text-[#1F8A4C]">
          <CheckCircle2 size={18} strokeWidth={2.4} aria-hidden="true" />
        </div>
        <div className="min-w-0">
          <p className="text-sm font-bold">Tudo certo</p>
          <p className="mt-0.5 text-sm font-medium leading-5 text-[#5A5147]">{message}</p>
        </div>
        <button
          className="flex h-7 w-7 items-center justify-center rounded-md text-[#5A5147] transition hover:bg-[#F8E1E7] hover:text-[#1A1A1A]"
          type="button"
          aria-label="Fechar notificação"
          onClick={onClose}
        >
          <X size={16} strokeWidth={2.2} />
        </button>
      </div>
    </div>
  )
}
